module.exports = "//static.hsappstatic.net/marketplace-unified-public-ui/static-1.1878/img/screenshot-og.png"